import React from 'react'
const Footer = () => {
  return (
    <footer className="mt-auto w-full bg-black text-center text-sm text-white py-3">
      © Copyright 2026
      <span className="font-semibold"> Fattan Hibrizi </span>
       dibuat dengan 💖 untuk para calon astronot
    </footer>
  )
}

export default Footer
